/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { 
  FacebookShareButton, 
  FacebookIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestShareButton,
  PinterestIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
  TelegramShareButton,
  TelegramIcon,
  RedditShareButton,
  RedditIcon,
  TumblrShareButton,
  TumblrIcon,
  VKShareButton,
  VKIcon,
  PocketShareButton,
  PocketIcon,
  LineShareButton,
  LineIcon,
  ViberShareButton,
  ViberIcon,
  WorkplaceShareButton,
  WorkplaceIcon,
  WeiboShareButton,
  WeiboIcon,
  InstapaperShareButton,
  InstapaperIcon,
  HatenaShareButton,
  HatenaIcon,
  LivejournalShareButton,
  LivejournalIcon,
  MailruShareButton,
  MailruIcon,
  OKShareButton,
  OKIcon
} from "react-share"

import { getShareButtonStyle } from './shareButtonStyle'

function CustomShareIcon({ path, bgColor, clipId, size = 50 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id={clipId}>
          <circle cx="12" cy="12" r="12" />
        </clipPath>
      </defs>
      <circle cx="12" cy="12" r="12" fill={bgColor} />
      <g clipPath={`url(#${clipId})`}>
        <g transform="translate(4 4) scale(0.667)">
          <path d={path} fill="white" />
        </g>
      </g>
    </svg>
  )
}

export function ShareThisWidget({ 
  shareUrl, 
  pageTitle = null, 
  topLabel = 'SHARE THIS PAGE:',
  selectedPlatforms = ['facebook', 'whatsapp', 'email'],
  buttonPosition = 'center'
}) {
  const s = getShareButtonStyle()
  const title = pageTitle || (typeof window !== 'undefined' ? window.document.title : '')
  
  const allPlatforms = [
    // Most popular platforms (react-share supported)
    { key: 'facebook', name: 'Facebook', component: FacebookShareButton, icon: FacebookIcon, isCustom: false },
    { key: 'facebook-messenger', name: 'Facebook Messenger', component: FacebookMessengerShareButton, icon: FacebookMessengerIcon, isCustom: false },
    { key: 'x-twitter', name: 'X (Twitter)', component: TwitterShareButton, icon: TwitterIcon, isCustom: false, svgBgColor: '#000000', svgPath: 'M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993zm-2.837 3.299-.929-1.329L3.076 1.56h3.182l5.965 8.532.929 1.329 7.754 11.09h-3.182z' },
    { key: 'whatsapp', name: 'WhatsApp', component: WhatsappShareButton, icon: WhatsappIcon, isCustom: false },
    { key: 'telegram', name: 'Telegram', component: TelegramShareButton, icon: TelegramIcon, isCustom: false },
    { key: 'linkedin', name: 'LinkedIn', component: LinkedinShareButton, icon: LinkedinIcon, isCustom: false },
    { key: 'pinterest', name: 'Pinterest', component: PinterestShareButton, icon: PinterestIcon, isCustom: false },
    { key: 'email', name: 'Email', component: EmailShareButton, icon: EmailIcon, isCustom: false },
    
    // Regional and specialised platforms (react-share supported)
    { key: 'vk', name: 'VK', component: VKShareButton, icon: VKIcon, isCustom: false },
    { key: 'reddit', name: 'Reddit', component: RedditShareButton, icon: RedditIcon, isCustom: false },
    { key: 'tumblr', name: 'Tumblr', component: TumblrShareButton, icon: TumblrIcon, isCustom: false },
    { key: 'pocket', name: 'Pocket', component: PocketShareButton, icon: PocketIcon, isCustom: false },
    { key: 'odnoklassniki', name: 'Odnoklassniki', component: OKShareButton, icon: OKIcon, isCustom: false },
    { key: 'mail-ru', name: 'Mail.Ru', component: MailruShareButton, icon: MailruIcon, isCustom: false },
    { key: 'livejournal', name: 'LiveJournal', component: LivejournalShareButton, icon: LivejournalIcon, isCustom: false },
    { key: 'viber', name: 'Viber', component: ViberShareButton, icon: ViberIcon, isCustom: false },
    { key: 'workplace', name: 'Workplace', component: WorkplaceShareButton, icon: WorkplaceIcon, isCustom: false },
    { key: 'line', name: 'Line', component: LineShareButton, icon: LineIcon, isCustom: false },
    { key: 'weibo', name: 'Weibo', component: WeiboShareButton, icon: WeiboIcon, isCustom: false },
    { key: 'instapaper', name: 'Instapaper', component: InstapaperShareButton, icon: InstapaperIcon, isCustom: false },
    { key: 'hatena', name: 'Hatena', component: HatenaShareButton, icon: HatenaIcon, isCustom: false },

    // Custom implementations for platforms not in react-share
    { key: 'gab', name: 'Gab', component: null, icon: null, isCustom: true, url: 'https://gab.com/compose?url={url}&text={title}' },
    { key: 'bluesky', name: 'Bluesky', component: null, icon: null, isCustom: true, url: 'https://bsky.app/intent/compose?text={title} {url}', svgBgColor: '#1185FE', svgPath: 'M5.202 2.857C7.954 4.922 10.913 9.11 12 11.358c1.087-2.247 4.046-6.436 6.798-8.501C20.783 1.366 24 .213 24 3.883c0 .732-.42 6.156-.667 7.037-.856 3.061-3.978 3.842-6.755 3.37 4.854.826 6.089 3.562 3.422 6.299-5.065 5.196-7.28-1.304-7.847-2.97-.104-.305-.152-.448-.153-.327 0-.121-.05.022-.153.327-.568 1.666-2.782 8.166-7.847 2.97-2.667-2.737-1.432-5.473 3.422-6.3-2.777.473-5.899-.308-6.755-3.369C.42 10.04 0 4.615 0 3.883c0-3.67 3.217-2.517 5.202-1.026' },
    { key: 'threads', name: 'Threads', component: null, icon: null, isCustom: true, url: 'https://www.threads.net/intent/post?text={title} {url}', svgBgColor: '#000000', svgPath: 'M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z' },
    
    // Custom options
    { key: 'instagram', name: 'Instagram', component: null, icon: null, isCustom: true, url: 'https://www.instagram.com/', isSpecial: true },
    { key: 'copy-link', name: 'Copy Link', component: null, icon: null, isCustom: true, url: '', isSpecial: true }
  ]

  const renderShareButton = (platform) => {
    const { key, name, component: ShareButton, icon: Icon, isCustom, url: customUrl, isSpecial, svgPath, svgBgColor } = platform
    const isEnabled = selectedPlatforms.includes(key)
    
    if (!isEnabled) return null

    // Handle special platforms (Instagram and Copy Link)
    if (isSpecial) {
      if (key === 'instagram') {
        const handleInstagramShare = () => {
          const shareText = `${title}\n\n${shareUrl}`
          
          // Create a better user experience with a modal
          const modal = document.createElement('div')
          modal.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.8);
            z-index: 10000;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Arial, sans-serif;
          `
          
          modal.innerHTML = `
            <div style="
              background: white;
              padding: 30px;
              border-radius: 10px;
              max-width: 500px;
              width: 90%;
              text-align: center;
              box-shadow: 0 10px 30px rgba(0,0,0,0.3);
              position: relative;
            ">
              <button onclick="this.closest('.instagram-modal').remove()" style="
                position: absolute;
                top: 15px;
                right: 15px;
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                color: #999;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: background-color 0.2s;
              " onmouseover="this.style.backgroundColor='#f0f0f0'" onmouseout="this.style.backgroundColor='transparent'">×</button>
              <div style="
                width: 60px;
                height: 60px;
                background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
                border-radius: 15px;
                margin: 0 auto 20px auto;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 15px rgba(225, 48, 108, 0.3);
              ">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </div>
              <h3 style="color: #E4405F; margin: 0 0 20px 0; font-size: 24px;">Share on Instagram</h3>
              <p style="margin: 0 0 20px 0; color: #666; line-height: 1.5;">
                Content has been copied to your clipboard!<br>
                Follow these steps to share on Instagram:
              </p>
              <div style="
                background: #f8f9fa;
                padding: 15px;
                border-radius: 8px;
                margin: 20px 0;
                text-align: left;
                font-family: monospace;
                font-size: 14px;
                white-space: pre-wrap;
                border-left: 4px solid #E4405F;
              ">${shareText}</div>
              <ol style="text-align: left; margin: 20px 0; padding-left: 20px;">
                <li>Open Instagram app on your phone</li>
                <li>Tap the + button to create a new post</li>
                <li>Add your photo/video</li>
                <li>Tap "Write a caption..." and paste the content</li>
                <li>Share your post!</li>
              </ol>
              <div style="margin-top: 25px;">
                <button onclick="this.closest('.instagram-modal').remove()" style="
                  background: #E4405F;
                  color: white;
                  border: none;
                  padding: 12px 24px;
                  border-radius: 6px;
                  cursor: pointer;
                  font-size: 16px;
                  margin-right: 10px;
                ">Got it!</button>
                <button onclick="
                  navigator.clipboard.writeText('${shareText.replace(/'/g, "\\'")}');
                  this.textContent = 'Copied again!';
                  setTimeout(() => this.textContent = 'Copy again', 2000);
                " style="
                  background: #6c757d;
                  color: white;
                  border: none;
                  padding: 12px 24px;
                  border-radius: 6px;
                  cursor: pointer;
                  font-size: 16px;
                ">Copy again</button>
              </div>
            </div>
          `
          
          modal.className = 'instagram-modal'
          document.body.appendChild(modal)
          
          // Copy to clipboard
          navigator.clipboard.writeText(shareText).catch(() => {
            // Fallback if clipboard fails
            const textArea = document.createElement('textarea')
            textArea.value = shareText
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
          })
        }
        
        return (
          <span key={key} title="Copy content for Instagram sharing">
            <button 
              onClick={handleInstagramShare}
              css={s.shareButton}
              style={{ 
                display: 'inline-block',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                color: 'white',
                textDecoration: 'none',
                textAlign: 'center',
                lineHeight: '50px',
                fontSize: '20px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(225, 48, 108, 0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.05)'
                // e.target.style.boxShadow = '0 4px 12px rgba(225, 48, 108, 0.4)'
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)'
                // e.target.style.boxShadow = '0 2px 8px rgba(225, 48, 108, 0.3)'
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </button>
          </span>
        )
      }
      
      if (key === 'copy-link') {
        const handleCopyLink = async () => {
          try {
            await navigator.clipboard.writeText(shareUrl)
            // You could add a toast notification here
            alert('Link copied to clipboard!')
          } catch (err) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea')
            textArea.value = shareUrl
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
            alert('Link copied to clipboard!')
          }
        }
        
        return (
          <span key={key} title="Copy link to clipboard">
            <button 
              onClick={handleCopyLink}
              css={s.shareButton}
              style={{ 
                display: 'inline-block',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: '#28a745', // Green color for copy action
                color: 'white',
                textDecoration: 'none',
                textAlign: 'center',
                lineHeight: '50px',
                fontSize: '16px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
              }}
              onMouseOver={(e) => {
                // e.target.style.backgroundColor = '#218838'
                e.target.style.transform = 'scale(1.05)'
              }}
              onMouseOut={(e) => {
                // e.target.style.backgroundColor = '#28a745'
                e.target.style.transform = 'scale(1)'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
              </svg>
            </button>
          </span>
        )
      }
    }

    // Handle custom platforms (not in react-share)
    if (isCustom) {
      const encodedUrl = encodeURIComponent(shareUrl)
      const encodedTitle = encodeURIComponent(title)
      const finalUrl = customUrl.replace('{url}', encodedUrl).replace('{title}', encodedTitle)

      if (svgPath) {
        return (
          <span key={key} title={`Sharing with ${name}`}>
            <a
              href={finalUrl}
              target="_blank"
              rel="noopener noreferrer"
              css={s.shareButton}
              style={{ display: 'inline-block', textDecoration: 'none', transition: 'all 0.2s ease' }}
              onMouseOver={(e) => { e.currentTarget.style.transform = 'scale(1.05)' }}
              // onMouseOut={(e) => { e.currentTarget.style.transform = 'scale(1)' }}
            >
              <CustomShareIcon path={svgPath} bgColor={svgBgColor} clipId={`si-${key}`} size={50} />
            </a>
          </span>
        )
      }

      return (
        <span key={key} title={`Sharing with ${name}`}>
          <a 
            href={finalUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            css={s.shareButton}
            style={{ 
              display: 'inline-block',
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              backgroundColor: '#4267B2',
              color: 'white',
              textDecoration: 'none',
              textAlign: 'center',
              lineHeight: '50px',
              fontSize: '12px',
              fontWeight: 'bold',
              transition: 'all 0.2s ease',
              boxShadow: '0 2px 8px rgba(66, 103, 178, 0.3)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)'
              // e.currentTarget.style.boxShadow = '0 4px 12px rgba(66, 103, 178, 0.4)'
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)'
              // e.currentTarget.style.boxShadow = '0 2px 8px rgba(66, 103, 178, 0.3)'
            }}
          >
            {name.charAt(0)}
          </a>
        </span>
      )
    }

    // Handle react-share platforms
    const shareProps = {
      url: shareUrl,
      css: [s.shareButton, {
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'scale(1.05)',
          // boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
        }
      }]
    }

    // Add platform-specific props
    const titlePlatforms = ['x-twitter', 'linkedin', 'telegram', 'reddit', 'tumblr', 'pocket',
      'odnoklassniki', 'mail-ru', 'livejournal', 'viber', 'line', 'weibo', 'instapaper', 'hatena']
    if (titlePlatforms.includes(key)) {
      shareProps.title = title
    } else if (key === 'email') {
      shareProps.subject = title
    } else if (key === 'pinterest') {
      shareProps.media = shareUrl
    }

    return (
      <span key={key} title={`Sharing with ${name}`}>
        <ShareButton {...shareProps}>
          {svgPath
            ? <CustomShareIcon path={svgPath} bgColor={svgBgColor} clipId={`si-${key}`} size={50} />
            : <Icon size={50} round={true} />
          }
        </ShareButton>
      </span>
    )
  }

  const getButtonPositionStyle = () => {
    switch (buttonPosition) {
      case 'left':
        return { 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }
      case 'right':
        return { 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }
      case 'center':
      default:
        return { 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
    }
  }

  return (
    <div css={[s.shareButtons, getButtonPositionStyle()]}>
      {topLabel && <div css={s.shareButtonTitle}>{topLabel}</div>}
      
      <div css={s.shareButtonsContainer}>
        {allPlatforms.map(renderShareButton)}
      </div>
    </div>
  )
}
